<template>
  <animation-layout :cclink="cclink">
    <div style="padding:35px" v-if="item">
      <div style="text-align:center;">
        <img :src="$assetUrl('scrapbook.png')" alt="Scrapbook"  />
        <div style="color:#6d6d64;font-size:38px;letter-spacing:-1px;margin-bottom:30px">
          Interview with an Animator
        </div>
        <div>
          <a :href="artistLink"><img :src="getImageUrl(item.artist)" alt="artist image" style="display:block;width:100%" /></a>
          <div style="background-color:#ce0e2d;color:#ffffff;font-size:40px;padding:10px 0">
            {{ formattedName }}
          </div>
        </div>
        <div v-html="formattedIntro" style="font-size:19px;line-height:28px;text-align:center"></div>
        <div style="margin:24px 0">
          <a :href="firstLink"><img :src="getImageUrl(item.first)" alt="first image" style="display:block;width:100%" /></a>
        </div>
        <div v-html="interview" style="font-size:19px;line-height:28px;text-align:center"></div>
        <div style="margin:24px">
          <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
            :href="portfolioLink">view {{ firstName }}'s portfolio</a>
        </div>
        <div style="margin:24px 0">
          <a :href="secondLink"><img :src="getImageUrl(item.second)" alt="second image" style="display:block;width:100%" /></a>
        </div>
        
        <div style="margin:24px 0" v-if="item.playlistUrl">
          <div style="font-size:22px"><a :href="item.playlistUrl" style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#222;border-radius:6px" >{{ item.playlistTitle}}</a></div>
        </div>
        <div style="margin:24px 0">
          <a :href="studioLink"><img :src="getImageUrl(item.studio)" alt="studio image" style="display:block;width:100%" /></a>
        </div>
        <div style="margin-bottom:24px">
          <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
            :href="portfolioLink">view {{ firstName }}'s portfolio</a>
        </div>
      </div>  
    </div>
  </animation-layout>
</template>

<script>
import AnimationLayout from '../layouts/AnimationLayout.vue'
import { setMetaDescription, removeMetaDescription } from '../metas.js'
export default {
  components: {
    AnimationLayout
  },
  props: {
    id: String
  },
  data () {
    return {
      item: null,
      formattedIntro: '',
      interview: '',
      cclink: this.$store.state.cclink + 'SCRAPBOOK'
    }
  },
  created () {
    console.log('id is', this.id)
    if(this.id) {
      this.loadData()
    }
  },
  beforeDestroy() {
    removeMetaDescription()
  },
  computed: {
    formattedName() {
      if(this.item) {
        return this.item.formatted_name
      }
      return ''
    },
    firstName () {
      if(this.item && this.item.formatted_name) {
        return this.item.formatted_name.split(' ').slice(0, 1)[0]
      }
      return ''
    },
    portfolioLink() {
      if(this.item) {
        return this.$host + '/animators/' + this.item.portfolio_url + this.ntlink
      }
      return ''
    },
    artistLink() {
      if(this.item) {
        if(this.item.artistLink) {
          return this.item.artistLink + this.ntlink
        }
      }
      return this.portfolioLink
    },
    firstLink() {
      if(this.item) {
        if(this.item.firstLink) {
          return this.item.firstLink + this.ntlink
        }
      }
      return this.portfolioLink
    },
    secondLink() {
      if(this.item) {
        if(this.item.secondLink) {
          return this.item.secondLink + this.ntlink
        }
      }
      return this.portfolioLink
    },
    studioLink() {
      if(this.item) {
        if(this.item.studioLink) {
          return this.item.studioLink + this.ntlink
        }
      }
      return this.portfolioLink
    },
    ntlink () {
      let ntlink = this.cclink
      if(this.item) {
        if(this.item.formatted_name) {
          ntlink = this.cclink + '&utm_content=' + encodeURIComponent(this.item.formatted_name)
        }
      }
      return ntlink
    }
  },
  methods: {
    async loadData() {
      let res = await this.$apix.get(`collections/multi/scrapbook-anim/${this.id}/EN`)
      this.formattedIntro = this.formatLines(res.data.interview1)
      this.interview = this.formatLines(res.data.interview2)
      this.item = res.data
      if(!this.item.metaTitle) {
        this.item.metaTitle = `${this.item.formatted_name}'s Animation Scrapbook Interview`
      }
      if(!this.item.metaDescription) {
        this.item.metaDescription = `Learn more about ${this.item.formatted_name}'s style and inspirations in this week's interview with an animator. Read the interview here.`
      }
      document.title = this.item.metaTitle
      setMetaDescription(this.item.metaDescription)
    },
    
    formatLines(text){
      if(!text){
        return ''
      }
      let lines = text.split('\n')
      let nf = []
      for(let i = 0; i < lines.length; i++) {
        if(i % 2 === 0) {
          nf.push('<div style="margin-top:10px;orphans:2"><span style="color:#ce0e2d;font-weight:500">' + lines[i] + '</span></div>')
        }
        else {
          nf.push("<div>" + lines[i] + "</div>")
        }
      }
      return nf.join('\n')
    },
    getImageUrl(name) {
      return `${this.$imagehost}/images/scrapbook/${name}`
    }
  }
}
</script>

<style>

</style>